const dbRequest = require('../../../../../js-network/db-request')
const fullcont = require('../../../../../components/fullcont/fullcont')
const multiselect = require('../../../../../components/textfield/textfield-multiselect')
const snack = require('../../../../../components/snack/snack')

const transactionTypeOptions = [
  { value: 'all', text: 'All' },
  { value: 'debit', text: 'Debit' },
  { value: 'credit', text: 'Credit' },
]

// Ignora respuestas pendientes al cerrar, guardar o cambiar de cuenta.
export function cancelRequest(htmlFc) {
  htmlFc.reportRequest = (htmlFc.reportRequest || 0) + 1
}

// Precarga el reporte al abrir la cuenta, sin navegar ni cambiar el formulario.
export async function load(htmlFc, transactionType = 'all') {
  const root = htmlFc.fullcontHTML
  if (root.classList.contains('mode-add') || !root.classList.contains('fullcont-show')) return

  const accountId = root.getAttribute('data-dbid') || ''
  if (!/^[1-9]\d*$/.test(accountId)) return
  if (!transactionTypeOptions.some(option => option.value === transactionType)) return

  const filter = root.querySelector('#accounts-report-transaction-type')
  if (htmlFc.reportAccountId !== accountId) {
    root.querySelector('#accounts-fullcont-report').innerHTML = ''
    htmlFc.reportAccountId = accountId
    htmlFc.reportTransactionType = 'all'
  }

  // Independiente de form/formCopy: filtrar no marca la cuenta como editada.
  multiselect.createChoose({
    html: filter,
    options: transactionTypeOptions,
    value: transactionType,
    includeEmptyOption: false,
  })

  cancelRequest(htmlFc)
  const request = htmlFc.reportRequest
  const isCurrent = () => request === htmlFc.reportRequest
    && root.getAttribute('data-dbid') === accountId
    && !root.classList.contains('mode-add')
    && root.classList.contains('fullcont-show')

  try {
    const result = await dbRequest.start({ inf: {
      entity: 'accounts',
      reportName: 'account-transation',
      filters: JSON.stringify({ entityId: accountId, transactionType }),
    } }, 'server/php/report/report-html.php')

    if (!isCurrent()) return
    if (result?.status !== 'ok') {
      multiselect.choose(filter, htmlFc.reportTransactionType)
      return
    }

    htmlFc.reportTransactionType = transactionType
    root.querySelector('#accounts-fullcont-report').innerHTML = result.data?.[0]?.html || ''
    root.querySelector('.accounts-report-page').scrollTop = 0
  } catch (error) {
    if (!isCurrent()) return
    multiselect.choose(filter, htmlFc.reportTransactionType)
    snack.start({ act: 'show', id: 'downloadError' })
  }
}

export function filterTransactions(htmlFc) {
  return load(htmlFc,
    multiselect.getFromHtml(htmlFc.fullcontHTML.querySelector('#accounts-report-transaction-type')))
}

export function returnToEntity(htmlFc) {
  fullcont.start({ act: 'pageMov', id: htmlFc.fullcontHTML.id, pagetoshow: 'entity' })
}

// Volver a Entity cuando Report deja de estar disponible o se carga otra cuenta.
export function reset(htmlFc) {
  cancelRequest(htmlFc)
  htmlFc.reportAccountId = ''
  htmlFc.reportTransactionType = 'all'
  htmlFc.fullcontHTML.querySelector('#accounts-fullcont-report').innerHTML = ''
  returnToEntity(htmlFc)
}
